import { isEnumValue } from '@core/utils';

import type { UnauthApi } from '@/api';
import { EXCEPTED_CODE, EXCEPTED_HIDDEN_CODE } from '@/api';

export type WelloPolicyCode = NonNullable<
  NonNullable<
    NonNullable<
      Awaited<
        ReturnType<
          (typeof UnauthApi)['get:/wello/v2/allows/wello-policy-code/all']
        >
      >['data']
    >['context']
  >['contents']
>[number];

export interface RegionMetaData {
  mainRegion: WelloPolicyCode[];
  mainRegionByCode: Map<string, WelloPolicyCode>;
  subRegion: WelloPolicyCode[];
  subRegionByCode: Map<string, WelloPolicyCode>;
  subRegionByParent: Map<string, WelloPolicyCode[]>;
}

export const buildRegionMetaData = (
  contents: WelloPolicyCode[],
): RegionMetaData => {
  const mainRegion: WelloPolicyCode[] = [];
  const mainRegionByCode = new Map<string, WelloPolicyCode>();
  const subRegion: WelloPolicyCode[] = [];
  const subRegionByCode = new Map<string, WelloPolicyCode>();
  const subRegionByParent = new Map<string, WelloPolicyCode[]>();

  contents.forEach((content) => {
    const { code, level, parentCode } = content;

    if (!code || !level) return;
    if (!code.includes(EXCEPTED_CODE.REGION)) return;

    const isHidden =
      code.includes('99') && !isEnumValue(EXCEPTED_HIDDEN_CODE, code);

    if (isHidden) return;

    if (level === 2) {
      mainRegion.push(content);
      mainRegionByCode.set(code, content);

      return;
    }

    if (level !== 3 || !parentCode) return;

    subRegion.push(content);
    subRegionByCode.set(code, content);

    const siblingSubRegions = subRegionByParent.get(parentCode);

    if (siblingSubRegions) siblingSubRegions.push(content);
    else subRegionByParent.set(parentCode, [content]);
  });

  subRegionByParent.forEach((siblingSubRegions) => {
    siblingSubRegions.sort((a, b) =>
      typeof a.value === 'string' && typeof b.value === 'string'
        ? a.value.localeCompare(b.value)
        : 0,
    );
  });

  return {
    mainRegion,
    mainRegionByCode,
    subRegion,
    subRegionByCode,
    subRegionByParent,
  };
};
